import {
    FETCH_ALL,
    FETCH_BY_CREATOR,
    FETCH_BY_SEARCH,
    START_LOADING,
    END_LOADING,
    CREATE,
    UPDATE,
    DELETE,
    LIKE,
    FETCH_POST,
    COMMENT,
    DELETE_COMMENT,
} from "../constants/actionTypes.js";

export default (state = { isLoading: true, posts: [] }, action) => {
    switch (action.type) {
        case START_LOADING:
            return { ...state, isLoading: true };
        case END_LOADING:
            return { ...state, isLoading: false };
        case FETCH_ALL:
            return {
                ...state,
                posts: action.payload.data,
                currentPage: action.payload.currentPage,
                numberOfPages: action.payload.numberOfPages,
            };
        case FETCH_POST:
            return { ...state, post: action.payload };
        case FETCH_BY_SEARCH:
        case FETCH_BY_CREATOR:
            return { ...state, posts: action.payload };
        case CREATE:
            return [...state, action.payload];
        case DELETE:
            return {
                ...state,
                posts: state.posts.filter(
                    (post) => post._id !== action.payload
                ),
            };
        case UPDATE:
        case LIKE:
            return {
                ...state,
                posts: state.posts.map((post) =>
                    post._id === action.payload._id ? action.payload : post
                ),
            };
        case COMMENT:
            return {
                ...state,
                posts: state.posts.map((post) => {
                    if (post._id === action.payload._id) return action.payload;

                    return post;
                }),
            };
        case DELETE_COMMENT:
            return {
                ...state,
                posts: state.posts.map((post) => {
                    if (post._id === action.payload._id) return action.payload;

                    return post;
                }),
            };

        default:
            return state;
    }
};
